const themes = [
  {
    name: 'theme1',
    colors: {
      bg: '#1f2125',
      'bg-variant': '#2e3238',
      primary: '#ff99cc',
      'primary-variant': 'rgba(255, 153, 204, 0.5)'
    }
  },
  {
    name: 'theme2',
    colors: {
      bg: '#1d1f21',
      'bg-variant': '#2e3133',
      primary: '#66ffcc',
      'primary-variant': 'rgba(102, 255, 204, 0.5)'
    }
  },
  {
    name: 'theme3',
    colors: {
      bg: '#1e1e26',
      'bg-variant': '#2c2c33',
      primary: '#ffcc66',
      'primary-variant': 'rgba(255, 204, 102, 0.5)'
    }
  },
  {
    name: 'theme4',
    colors: {
      bg: '#0d0d0d',
      'bg-variant': '#1a1a1a',
      primary: '#00ffcc',
      'primary-variant': 'rgba(0, 255, 204, 0.5)'
    }
  },
  {
    name: 'theme5',
    colors: {
      bg: '#0c0c15',
      'bg-variant': '#1b1b2a',
      primary: '#ff6600',
      'primary-variant': 'rgba(255, 102, 0, 0.5)'
    }
  },
  {
    name: 'theme10',
    colors: {
      bg: '#1f2125',
      'bg-variant': '#2e3238',
      primary: '#ff99cc',
      'primary-variant': 'rgba(255, 153, 204, 0.5)'
    }
  },
  {
    name: 'theme11',
    colors: {
      bg: '#1d1f21',
      'bg-variant': '#2e3133',
      primary: '#66ffcc',
      'primary-variant': 'rgba(102, 255, 204, 0.5)'
    }
  },
  {
    name: 'theme12',
    colors: {
      bg: '#1e1e26',
      'bg-variant': '#2c2c33',
      primary: '#ffcc66',
      'primary-variant': 'rgba(255, 204, 102, 0.5)'
    }
  },
  {
    name: 'theme13',
    colors: {
      bg: '#0d0d0d',
      'bg-variant': '#1a1a1a',
      primary: '#00ffcc',
      'primary-variant': 'rgba(0, 255, 204, 0.5)'
    }
  },
  {
    name: 'theme14',
    colors: {
      bg: '#0c0c15',
      'bg-variant': '#1b1b2a',
      primary: '#ff6600',
      'primary-variant': 'rgba(255, 102, 0, 0.5)'
    }
  },
  {
    name: 'theme15',
    colors: {
      bg: '#141414',
      'bg-variant': '#262626',
      primary: '#ff3399',
      'primary-variant': 'rgba(255, 51, 153, 0.5)'
    }
  },
  {
    name: 'theme16',
    colors: {
      bg: '#0f111a',
      'bg-variant': '#1f2538',
      primary: '#66b3ff',
      'primary-variant': 'rgba(102, 179, 255, 0.5)'
    }
  },
  {
    name: 'theme17',
    colors: {
      bg: '#121212',
      'bg-variant': '#1f1f1f',
      primary: '#ffcc00',
      'primary-variant': 'rgba(255, 204, 0, 0.5)'
    }
  },
  {
    name: 'theme18',
    colors: {
      bg: '#0e0e0e',
      'bg-variant': '#1c1c1c',
      primary: '#99ff66',
      'primary-variant': 'rgba(153, 255, 102, 0.5)'
    }
  },
  {
    name: 'theme19',
    colors: {
      bg: '#101013',
      'bg-variant': '#1e1e24',
      primary: '#ff5050',
      'primary-variant': 'rgba(255, 80, 80, 0.5)'
    }
  },
  {
    name: 'theme20',
    colors: {
      bg: '#131417',
      'bg-variant': '#1f2026',
      primary: '#ff66b2',
      'primary-variant': 'rgba(255, 102, 178, 0.5)'
    }
  }
]

export default themes
